export { parseName } from './parser';

export const isNil = (value) => value === null || value === undefined;
